import { UpdateSourceComponent } from './../update/update.component';
import { NbDialogService } from '@nebular/theme';
import { PagingService } from './../../../../shared/Services/PagingService';
import { SourceMasterService } from '../../services/source.master.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { CreateDataSourceComponent } from '../create/create.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sourcemaster-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetSourceMasterComponent extends BaseComponent implements OnInit {
  constructor(
    public route: Router,
    public service: SourceMasterService,
    public paging: PagingService,
    private diag: NbDialogService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.loadEntities();
  }

  formsfields(id) {
    this.route.navigate(['admin/dynamicForms/sources/master/' + id]);
  }

  addForm() {
    this.diag.open(CreateDataSourceComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

  update(id) {
    this.diag.open(UpdateSourceComponent, { context: { sourceId: id } }).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }
}
